import PropTypes from "prop-types";
import Stack from "@mui/material/Stack";
import ButtonBase from "@mui/material/ButtonBase";
import Box from "@mui/material/Box";
import { FP } from "./tokens";

/**
 * Filtros de estado en forma de píldoras, con conteo y un punto de color
 * opcional. Más livianos que unas Tabs para filtrar una lista:
 *
 *   <FiltroPildoras
 *     valor={filtro}
 *     onChange={setFiltro}
 *     opciones={[{ id: "pend", label: "Por aprobar", conteo: 3, color: FP.color.info }]}
 *   />
 */
export default function FiltroPildoras({ opciones, valor, onChange, sx }) {
  return (
    <Stack direction="row" useFlexGap flexWrap="wrap" gap={0.75} sx={sx}>
      {opciones.map((o) => {
        const activo = o.id === valor;
        return (
          <ButtonBase
            key={o.id}
            onClick={() => onChange(o.id)}
            aria-pressed={activo}
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 0.8,
              height: 34,
              px: 1.5,
              borderRadius: 999,
              border: `1px solid ${activo ? FP.color.navy : FP.color.border}`,
              bgcolor: activo ? FP.color.navy : FP.color.cardBg,
              color: activo ? "#FFFFFF" : FP.color.textSecondary,
              fontSize: "0.8rem",
              fontWeight: 600,
              whiteSpace: "nowrap",
              transition: "background-color 120ms, border-color 120ms, color 120ms",
              "&:hover": activo
                ? {}
                : {
                    borderColor: FP.color.borderStrong,
                    bgcolor: FP.color.surface,
                    color: FP.color.textPrimary,
                  },
              "&.Mui-focusVisible": {
                outline: `2px solid ${FP.color.accentBlue}`,
                outlineOffset: 2,
              },
            }}
          >
            {o.color ? (
              <Box
                component="span"
                sx={{
                  width: 7,
                  height: 7,
                  borderRadius: "50%",
                  bgcolor: o.color,
                  boxShadow: activo ? "0 0 0 2px rgba(255,255,255,0.35)" : "none",
                }}
              />
            ) : null}
            {o.label}
            {o.conteo !== undefined && o.conteo !== null ? (
              <Box
                component="span"
                sx={{
                  minWidth: 20,
                  height: 20,
                  px: 0.6,
                  borderRadius: 999,
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "0.7rem",
                  fontWeight: 700,
                  bgcolor: activo ? "rgba(255,255,255,0.18)" : FP.color.surfaceAlt,
                  color: activo ? "#FFFFFF" : FP.color.textSecondary,
                }}
              >
                {o.conteo}
              </Box>
            ) : null}
          </ButtonBase>
        );
      })}
    </Stack>
  );
}

FiltroPildoras.propTypes = {
  opciones: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
      conteo: PropTypes.number,
      color: PropTypes.string,
    })
  ).isRequired,
  valor: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  sx: PropTypes.objectOf(PropTypes.any),
};

FiltroPildoras.defaultProps = { sx: undefined };
